/* global $ */

import { Controller } from 'stimulus';

class Header extends Controller {
  onWindowClick(e) {
    const headerParent = e.target.closest('[data-controller="header"]');

    if (!headerParent) {
      this.closeAllDropdowns();
    }
  }

  closeAllDropdowns() {
    const dropdowns = Array.prototype.slice.call(this.element.querySelectorAll('.collapse.show'));

    dropdowns.forEach((dropdown) => {
      $(dropdown).collapse('hide');
    });
  }
}

Header.targets = [
  //
];

export default Header;
